import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CalendarClock, ExternalLink, Info } from "lucide-react";
import { toast } from "sonner";
import api from "../api";
import { usePageTitle } from "../components/common";
import { BOOKING_NOTICE } from "../content";

export default function Booking() {
  usePageTitle("Réserver mon créneau");
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [order, setOrder] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!sessionId) return;
    api.get(`/order/by-session/${sessionId}`).then((r) => {
      setOrder(r.data);
      if (!r.data.booking_required) navigate(`/confirmation?session_id=${sessionId}`);
    }).catch(() => {});
  }, [sessionId]);

  const confirmBooked = async () => {
    setSaving(true);
    try {
      await api.post("/booking", { session_id: sessionId });
      toast.success("Ton créneau est bien enregistré ✨");
      navigate(`/confirmation?session_id=${sessionId}`);
    } catch {
      toast.error("Une erreur est survenue.");
    } finally {
      setSaving(false);
    }
  };

  if (!sessionId) return <div className="container-x py-24 text-center text-[#7A5D58]">Session introuvable.</div>;
  if (!order) return <div className="container-x py-24 text-center text-[#7A5D58]">Chargement…</div>;

  const hasCal = !!order.cal_event_url;

  return (
    <div className="container-x py-10 sm:py-16 fade-up max-w-2xl">
      <div className="flex items-center gap-3 mb-2">
        <CalendarClock className="text-[#C9A56A]" size={26} />
        <h1 className="font-serif text-3xl sm:text-4xl font-medium text-[#5A3A4B]">Réserve ton créneau</h1>
      </div>
      <p className="text-sm text-[#7A5D58]">{order.service_name}</p>

      <div className="mt-6 rounded-2xl border border-[#C9A56A]/40 bg-[#C9A56A]/10 p-5 flex gap-3">
        <Info className="text-[#8a6a2f] shrink-0 mt-0.5" size={20} />
        <p className="text-sm text-[#7A5D58] leading-relaxed whitespace-pre-line">{BOOKING_NOTICE}</p>
      </div>

      <div className="mt-6 card-soft p-6">
        {hasCal ? (
          <>
            <div className="rounded-xl overflow-hidden border border-[#7A5D58]/10" style={{ height: 620 }}>
              <iframe
                title="Réservation Cal.com"
                src={order.cal_event_url}
                className="w-full h-full"
                data-testid="cal-iframe"
              />
            </div>
            <a
              href={order.cal_event_url}
              target="_blank"
              rel="noreferrer"
              className="mt-4 inline-flex items-center gap-2 text-sm text-[#5A3A4B] underline"
            >
              Ouvrir le calendrier dans un nouvel onglet <ExternalLink size={14} />
            </a>
          </>
        ) : (
          <div className="text-center py-8">
            <p className="text-[#7A5D58] leading-relaxed">
              Le calendrier de réservation sera bientôt disponible ici. Noëmie te contactera pour
              convenir du moment dédié à ta séance, selon la préférence de contact que tu as indiquée.
            </p>
          </div>
        )}
      </div>

      <button onClick={confirmBooked} disabled={saving} className="btn-primary w-full mt-6" data-testid="booking-confirm-btn">
        {saving ? "Enregistrement…" : "J'ai réservé mon créneau"}
      </button>
    </div>
  );
}
